import { call, fork, put, race, take, takeLatest } from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import { io } from "socket.io-client";

import {
  startNotificationSocket,
  addSocketNotification,
} from "../../redux/notifications/notifications";
import { logoutStart } from "../../redux/auth/authentication";
import { showErrorMessage } from "../../redux/toast";
import config from "../../../utils/config";
import session from "../../../utils/session";

const customParser = require("socket.io-msgpack-parser");

function connect() {
  const user = session.getSessionCred;
  const socket = io(`${config.baseUrl}/notifications`, {
    auth: {
      "access-token": `${user.token}`,
    },
    transports: ["websocket"],
    parser: customParser,
  });
  return new Promise((resolve, reject) => {
    socket.on("connect", () => resolve(socket));
    socket.on("connect_error", (err) => reject(err));
  });
}

function subscribe(socket) {
  return eventChannel((emitter) => {
    socket.on("user-notifications", (data) => {
      emitter(data);
    });
    return () => {};
  });
}

function* read(socket) {
  try {
    const channel = yield call(subscribe, socket);
    while (true) {
      const { logoutAction, socketData } = yield race({
        logoutAction: take(logoutStart.type),
        socketData: take(channel),
      });
      if (logoutAction) {
        channel.close();
        socket.disconnect();
        break;
      } else {
        yield put(addSocketNotification(socketData));
      }
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* notificationSocketWorker() {
  try {
    const socket = yield call(connect);
    yield fork(read, socket);
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

function* notificationSocketWatcher() {
  yield takeLatest(startNotificationSocket.type, notificationSocketWorker);
}

export default notificationSocketWatcher;
